module.exports = __webpack_public_path__ + "static/media/conheca-joinville2.d4f9f351.webp";